import { environment } from '../../../../environments/environment';
// import * as angular from 'angular';

(function () {
  'use strict';

  angular.module('app').service('TourInventoryService', TourInventoryService);

  TourInventoryService.$inject = [
    'RestResource',
    '$translate',
    '$filter',
    'UtilService',
    'TourInventoryModalService',
  ];

  function TourInventoryService(
    RestResource,
    $translate,
    $filter,
    UtilService,
    TourInventoryModalService
  ) {
    var utils = new UtilService(this);

    $translate = $filter('translate');

    var apiUrl = environment.apiEndpoint + 'tour_inventories';

    var service = {
      getTourInventory: getTourInventory,
      saveTourInventory: saveTourInventory,
      saveTourInventoriesByDates: saveTourInventoriesByDates,
      openTourInventoryModal: openTourInventoryModal,
    };

    return service;

    ////////////////

    function getTourInventory(filterCriteria) {
      if (!filterCriteria) {
        filterCriteria = {};
      }

      return RestResource.request(
        'get',
        apiUrl,
        filterCriteria,
        function (response) {
          return response.data;
        },
        function () {
          return false;
        }
      );
    }

    function saveTourInventory(item) {
      function success(response) {
        utils._successMsg($translate('INVENTORY_UPDATED'));

        if (!item.id) {
          // New
          item.id = response.data.id;
        }

        item.total_availability = response.data.total_availability;

        utils.itemListChanged(item.id);

        return true;
        // return response;
      }
      function failure(response) {
        utils._errorMsg(response.data.error);
        return false;
      }

      var method = item.id ? 'put' : 'post';
      var url = item.id ? apiUrl + '/' + item.id : apiUrl;

      return RestResource.request(method, url, item, success, failure);
    }

    function saveTourInventoriesByDates(item) {
      function success() {
        utils._successMsg($translate('INVENTORY_UPDATED'));
        return true;
      }
      function failure(response) {
        console.log(response);
        utils._errorMsg(response.data.error);
        return false;
      }

      var url = apiUrl + '/change_total_by_dates';

      return RestResource.request('post', url, item, success, failure);
    }

    function openTourInventoryModal(item, successCallback) {
      TourInventoryModalService.openTourInventoryModal(item, successCallback);
    }
  }
})();
